module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"alert":{"destination":"لطفا مقصد را انتخاب کنید","checkIn":"لطفا تاریخ ورود را انتخاب کنید","checkout":"لطفا تاریخ خروج را انتخاب کنید"}}}')
  delete Component.options._Ctor
}
